<template>
  <v-container id="distribution">
    <v-layout column>
      <v-flex mb-2>
        <v-layout row>
          <v-flex class="filtersBar">
            <filters-bar
              @search="getData"
              title="Chatcenter"
              title-class="headline" 
              title-box-size="md3"
              date-box-size="md3"
              :filtersButton="false"
              :filters="filters"
              :has-date-type="true">
              <template slot="content">
                <v-flex md2 class="download-btn-wrap">
                  <v-menu bottom offset-y left class="download-menu">
                    <v-btn
                      slot="activator"
                      block
                      class="h-100 ma-0 w-100">
                      <v-icon small>fas fa-download</v-icon>
                    </v-btn>
                    <v-list class="pa-0">
                      <v-list-tile @click="generateReport">
                        <v-list-tile-title>
                          Descargar reporte
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile
                        v-if="canDownloadConversation"
                        @click="generateConversationPdfs">
                        <v-list-tile-title>
                          Descargar reporte con PDF
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-flex>
              </template>
            </filters-bar>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex>
        <v-card>
          <v-card-text class="clickable" @click="showChannels = true">
            <v-layout>
              <v-flex md8>
                <v-layout h-100 column>
                  <v-flex>
                    <span>
                      Distribución
                    </span>
                  </v-flex>
                  <v-flex h-100>
                    <transition name="fade-effect" mode="out-in">
                      <skeleton-box v-if="isSearching || !loadedCharts" flat>
                        <skeleton-line class="custom-skeleton-line">
                        </skeleton-line>
                      </skeleton-box>
                      <template v-else>
                        <line-graphics @click.stop v-if="graphicData.length > 0" :data="graphicData"></line-graphics>
                        <template v-else>
                          <v-layout row class="sizebox align-center h-100">
                            <v-flex class="text-xs-center">
                              <span class="headline">
                                No hay información
                              </span>
                            </v-flex>
                          </v-layout>
                        </template>
                      </template>
                    </transition>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md4>
                <v-layout row wrap>
                  <v-flex xs12>
                    <span>
                      Chats
                    </span>
                  </v-flex>
                  <transition name="fade-effect" mode="out-in">
                    <template v-if="isSearching">
                      <skeleton-box class="w-100" flat>
                        <v-flex  v-for="i in 5" :key="`skeleton-line-${i}`"  mt-3 xs12>
                          <v-layout flex>
                            <v-flex md1 pr-1 pt-2>
                              <skeleton-line class="skeleton-square"></skeleton-line>
                            </v-flex>
                            <v-flex md11>
                              <skeleton-line class="skeleton-progress mt-3"></skeleton-line>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </skeleton-box>
                    </template>
                    <template v-else>
                      <div class="w-100">
                        <v-flex  mt-3 xs12>
                          <v-layout flex>
                            <v-flex md1 pr-1 pt-2>
                              <div style="background: #ce6eeb" class="square">
                              </div>
                            </v-flex>
                            <v-flex md11>
                              <v-layout row wrap>
                                <v-flex md8>
                                  <span>
                                    Total
                                  </span>
                                </v-flex>
                                <v-flex class="text-xs-right" md4>
                                  <span>
                                    {{totals.total}}
                                  </span>
                                </v-flex>
                                <v-flex md12>
                                  <v-progress-linear
                                    :color="`linear-0`"
                                    class="custom-progress"
                                    height="8"
                                    :value="pecent(Number(totals.total))" />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex  mt-3 xs12>
                          <v-layout flex>
                            <v-flex md1 pr-1 pt-2>
                              <div style="background: #4bdae7" class="square">
                              </div>
                            </v-flex>
                            <v-flex md11>
                              <v-layout row wrap>
                                <v-flex md8>
                                  <span>
                                    En espera
                                  </span>
                                </v-flex>
                                <v-flex class="text-xs-right" md4>
                                  <span>
                                    {{totals.queued}}
                                  </span>
                                </v-flex>
                                <v-flex md12>
                                  <v-progress-linear
                                    :color="`linear-1`"
                                    class="custom-progress"
                                    height="8"
                                    :value="pecent(Number(totals.queued))" />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex  mt-3 xs12>
                          <v-layout flex>
                            <v-flex md1 pr-1 pt-2>
                              <div style="background: #fcae32" class="square">
                              </div>
                            </v-flex>
                            <v-flex md11>
                              <v-layout row wrap>
                                <v-flex md8>
                                  <span>
                                    Por responder
                                  </span>
                                </v-flex>
                                <v-flex class="text-xs-right" md4>
                                  <span>
                                    {{totals.unanswered}}
                                  </span>
                                </v-flex>
                                <v-flex md12>
                                  <v-progress-linear
                                    :color="`linear-2`"
                                    class="custom-progress"
                                    height="8"
                                    :value="pecent(Number(totals.unanswered))" />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex  mt-3 xs12>
                          <v-layout flex>
                            <v-flex md1 pr-1 pt-2>
                              <div style="background: #f46860" class="square">
                              </div>
                            </v-flex>
                            <v-flex md11>
                              <v-layout row wrap>
                                <v-flex md8>
                                  <span>
                                    Por respuesta del cliente
                                  </span>
                                </v-flex>
                                <v-flex class="text-xs-right" md4>
                                  <span>
                                    {{totals.unsolved}}
                                  </span>
                                </v-flex>
                                <v-flex md12>
                                  <v-progress-linear
                                    :color="`linear-3`"
                                    class="custom-progress"
                                    height="8"
                                    :value="pecent(Number(totals.unsolved))" />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex  mt-3 xs12>
                          <v-layout flex>
                            <v-flex md1 pr-1 pt-2>
                              <div style="background: #65e4a1" class="square">
                              </div>
                            </v-flex>
                            <v-flex md11>
                              <v-layout row wrap>
                                <v-flex md8>
                                  <span>
                                    Resueltos
                                  </span>
                                </v-flex>
                                <v-flex class="text-xs-right" md4>
                                  <span>
                                    {{totals.solved}}
                                  </span>
                                </v-flex>
                                <v-flex md12>
                                  <v-progress-linear
                                    :color="`linear-4`"
                                    class="custom-progress"
                                    height="8"
                                    :value="pecent(Number(totals.solved))" />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </div>
                    </template>
                  </transition>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <channels-modal
      v-if="loadedCharts"
      :data="modalData" 
      :filters="filters" 
      @search="getData" 
      :show="showChannels"
       @close="showChannels = $event"></channels-modal>
    <v-dialog v-model="pdfDownloadDialog" persistent width="50%">
      <v-card>
        <v-card-text class="pt-4 pb-4">
          <v-layout row wrap class="px-3">
            <v-flex xs12 class="text-xs-center mb-3">
              <v-icon class="f3-5em k-orange-linear-text">fas fa-download</v-icon>
            </v-flex>
            <v-flex xs12 class="text-xs-center f1-1em my-2">
              ¡Se ha generado su reporte a de manera exitosa!
            </v-flex>
            <v-flex xs12 class="text-xs-center">
              <v-btn
                class="k-orange-linear-text k-orange-linear-underline elevation-0"
                round
                @click="openPdfDownloadUrl">
                DESCARGAR
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import _ from 'lodash';
import moment from 'moment-timezone';
import FiltersBar from '@/components/global/FiltersBar';
import SkeletonLine from '@/components/global/skeletons/Line';
import SkeletonBox from '@/components/global/skeletons/SkeletonBox';
import permissionsMixin from '@/mixins/permissions';
import LineGraphics from './LineGraphic';
import ChannelsModal from './ChannelsModal';

export default {
  props: {
    loadedCharts: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [permissionsMixin],
  components: {
    FiltersBar,
    SkeletonBox,
    SkeletonLine,
    LineGraphics,
    ChannelsModal,
  },
  mounted() {
    this.getData();
    this.bindPdfDownloadListener();
  },
  beforeDestroy() {
    this.waitingPdfDownload = false;
  },
  data() {
    return {
      showChannels: false,
      dataTotals: {},
      total: 0,
      data: [],
      cancelToken: this.axios.CancelToken.source(),
      isSearching: true,
      filters: {
        date: moment().format('YYYY-MM-DD'),
        dateType: 'date',
      },
      waitingPdfDownload: false,
      pdfDownloadDialog: false,
      pdfDownloadUrl: '',
      pdfListenerBound: false,
    };
  },
  computed: {
    totals() {
      const data = {
        total: 0,
        queued: 0,
        solved: 0,
        unsolved: 0,
        unanswered: 0,
      };
      const transform = {
        queued: [1, 2, 3],
        unanswered: [4],
        unsolved: [5, 6],
        solved: [7],
      };
      let keys = Object.keys(transform);
      const temp = _.groupBy(this.dataTotals, (item) => {
        let key = 'queued';
        for (let i = 0; i < keys.length; i += 1) {
          if (transform[keys[i]].includes(item.chat_center_status_id)) {
            key = keys[i];
          }
        }
        return key;
      });
      keys = Object.keys(data);
      for (let i = 0; i < keys.length; i += 1) {
        data[keys[i]] = _.sumBy(temp[keys[i]], 'total');
      }
      return {
        ...data,
        total: this.total,
      };
    },
    modalData() {
      const grouped = _.groupBy(_.filter(this.dataTotals, 'channel_id'), 'channel_id');
      const data = [];
      const keys = Object.keys(grouped);
      for (let i = 0; i < keys.length; i += 1) {
        const actualValue = grouped[keys[i]];
        data[i] = {
          channel_id: actualValue[0].channel_id,
          data: [
            {
              category: 'Resueltos',
              value: 0,
              color: '#65e49f',
              include: [7],
            },
            {
              category: 'Por respuesta del cliente',
              value: 0,
              color: '#f4695d',
              include: [5],
            },
            {
              category: 'En espera',
              value: 0,
              color: '#4fdde5',
              include: [1, 2, 3],
            },
            {
              category: 'Por responder',
              value: 0,
              color: '#f9942d',
              include: [4],
            },
          ],
        };
        for (let j = 0; j < actualValue.length; j += 1) { // eslint-disable-next-line
          const insert = data[i].data.find(x => x.include.includes(actualValue[j].chat_center_status_id));
          if (insert) { // eslint-disable-next-line
            insert.value = insert.value + actualValue[j].total;
          }
        }
        data[i].data = _.filter(data[i].data, 'value');
      }
      return data;
    },
    graphicData() {
      const grouped = _.groupBy(this.data, 'hour');
      const data = [];
      const keys = Object.keys(grouped);
      for (let i = 0; i < 24; i += 1) {
        const hour = keys.find(x => Number(x) === i);
        data[i] = {
          hour: String(hour || i),
          queued: 0,
          solved: 0,
          unsolved: 0,
          unanswered: 0,
        };
        if (hour) {
          for (let j = 0; j < grouped[hour].length; j += 1) {
            data[i].queued += Number(grouped[hour][j].queued);
            data[i].solved += Number(grouped[hour][j].solved);
            data[i].unsolved += Number(grouped[hour][j].unsolved);
            data[i].unanswered += Number(grouped[hour][j].unanswered);
          }
        }
      }
      return data;
    },
    user() {
      return this.$auth.user();
    },
    canDownloadConversation() {
      return this.checkPermissions(['download_conversation']);
    },
  },
  methods: {
    generateReport() {
      this.$store.commit('SET_DOWNLOAD_CHANNEL', `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`);
      this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
        route: 'reports',
        params: {
          filters: {
            ...this.filters,
            filename: 'Chats',
          },
          functionName: 'chat_center',
        },
      });
    },
    generateConversationPdfs() {
      const isDaily = this.filters.dateType === 'date';
      const params = {
        type: isDaily ? 'diary' : 'monthly',
      };

      if (isDaily) {
        params.date = this.filters.date;
      } else {
        params.month = this.filters.date;
      }

      this.waitingPdfDownload = true;
      this.pdfDownloadUrl = '';
      this.bindPdfDownloadListener();
      this.axios.post('chat_centers/start-conversation-pdf-generation', params)
        .then(() => {
          this.$store.commit('SET_WAIT_DOWNLOAD_DIALOG', true);
        })
        .catch(() => {
          this.waitingPdfDownload = false;
          this.$store.commit('SET_DOWNLOAD_ERROR_DIALOG', true);
        });
    },
    bindPdfDownloadListener() {
      if (this.pdfListenerBound) {
        return;
      }
      this.pdfListenerBound = true;
      const channel = `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`;
      window.Echo.private(channel).listen('.reportGenerated', (event) => {
        this.onPdfReportGenerated(event);
      });
    },
    onPdfReportGenerated(event) {
      if (!this.waitingPdfDownload) {
        return;
      }

      let payload = event;
      if (typeof event === 'string') {
        try {
          payload = JSON.parse(event);
        } catch (e) {
          payload = {};
        }
      }

      // Only handle PDF payloads with url; leave filename reports to existing listeners
      if (!payload.url) {
        if (payload.filename === 'errorCatch') {
          this.waitingPdfDownload = false;
          this.$store.commit('SET_WAIT_DOWNLOAD_DIALOG', false);
          this.$store.commit('SET_DOWNLOAD_ERROR_DIALOG', true);
        }
        return;
      }

      this.waitingPdfDownload = false;
      this.pdfDownloadUrl = payload.url;
      this.$store.commit('SET_WAIT_DOWNLOAD_DIALOG', false);
      this.pdfDownloadDialog = true;
    },
    openPdfDownloadUrl() {
      if (this.pdfDownloadUrl) {
        window.open(this.pdfDownloadUrl, '_blank');
      }
      this.pdfDownloadDialog = false;
      this.pdfDownloadUrl = '';
    },
    cancelRequest() {
      this.cancelToken.cancel('');
      this.cancelToken = this.axios.CancelToken.source();
    },
    pecent(val) {
      let res = 0;
      if (val > 0) {
        res = (val * 100) / (Number(this.totals.total) || 1);
      } else {
        res = 0;
      }
      return res;
    },
    getData() {
      this.data = [];
      this.isSearching = true;
      this.cancelRequest();
      this.axios.get('chat/center/distribution', {
        cancelToken: this.cancelToken.token,
        params: {
          ...this.filters,
        },
      }).then(({ data }) => {
        const distribution = data.distribution;
        this.dataTotals = data.status;
        this.total = data.total;
        for (let i = 0; i < distribution.length; i += 1) {
          this.$set(this.data, i, {
            ...distribution[i],
            hour: moment.utc(`${distribution[i].date} ${distribution[i].hour}`, 'YYYYMMDD HH').local().format('HH'),
          });
        }
      }).catch(() => {}).then(() => {
        this.isSearching = false;
      });
    },
  },
};
</script>
<style scoped>
.custom-progress {
  margin: 0;
}
.custom-skeleton-line {
  height: 37vh;
  border-radius: 0 !important;
  width: 98%;
}
.skeleton-progress {
  height: 1.5vh;
  border-radius: 0 !important;
}
.square {
  width: 100%;
  height: 100%;
}
.skeleton-square {
  height: 3.5vh;
  width: 100%;
  background: #dedede;
  border-radius: 0 !important;
}
#distribution >>> .linear-0 {
  background-color: #ce6eeb !important;
  border-color: #ce6eeb !important;
}
#distribution >>> .linear-1 {
  background-color: #4bdae7 !important;
  border-color: #4bdae7 !important;
}
#distribution >>> .linear-2 {
  background-color: #fcae32 !important;
  border-color: #fcae32 !important;
}
#distribution >>> .linear-3 {
  background-color: #f46860 !important;
  border-color: #f46860 !important;
}
#distribution >>> .linear-4 {
  background-color: #65e4a1 !important;
  border-color: #65e4a1 !important;
}
#distribution .filtersBar >>> .container.grid-list-md.fluid {
  padding: 0;
}
#distribution .download-btn-wrap {
  display: flex;
  align-self: stretch;
}
#distribution .download-menu {
  display: block !important;
  width: 100%;
  height: 100%;
  min-height: 46px;
}
#distribution .download-menu >>> .menu__activator {
  display: block !important;
  width: 100%;
  height: 100%;
  min-height: 46px;
}
#distribution .download-menu >>> .btn {
  height: 100% !important;
  min-height: 46px !important;
}
</style>





// WEBPACK FOOTER //
// src/components/chat_center_v2/dashboard/Distributions/Index.vue